<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <a-input-search v-model="query['item.no']" :placeholder="$t('placeholder.itemNo')" allowClear class="query" @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['item.name']" :placeholder="$t('placeholder.itemName')" allowClear class="query" @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['lot.no']" :placeholder="$t('placeholder.lotNo')" allowClear class="query" @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['location.no']" :placeholder="$t('placeholder.location')" allowClear class="query" @pressEnter="search" @search="search"/>
      <a-button type="primary" @click="search">{{ $t('button.query') }}</a-button>
      <a-button type="primary" @click="reset">{{ $t('button.reset') }}</a-button>
      <a-button type="primary" @click="maintain">{{ $t('button.maintain') }}</a-button>
      <a-button type="primary" @click="del">{{ $t('button.delete') }}</a-button>
      <a-button type="primary" @click="generate">{{ $t('button.maintenancePlanGeneration') }}</a-button>
      <a-select v-model="batchEdit.maintenanceWay" :placeholder="$t('placeholder.maintenanceMeasure')" allowClear class="query" @change="batchEditMaintenanceWay">
        <a-select-option v-for="d in maintenanceWays" :key="d.ordinal">{{ d.name }}</a-select-option>
      </a-select>
      <a-input v-model="batchEdit.maintainAdvice" :placeholder="$t('placeholder.maintenanceAdvice')" allowClear class="query" @change="batchEditMaintainAdvice" @pressEnter="batchEditMaintainAdvice"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      align="center"
      ref="table"
      :data="data"
      :loading="loading"
      size="mini"
      :height="scrollY"
      keep-source
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      :checkbox-config="{trigger: 'cell'}"
      :edit-rules="editRules"
      :edit-config="editConfig"
      :scroll-x="{enabled: true}"
      style="margin-top: 2px">
      <vxe-column fixed="left" type="checkbox" width="50"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="maintenance.important" title="business.label.important" width="70"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName" width="200"/>
      <vxe-column field="pack.specification" title="business.label.specification" width="150"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="70"/>
      <vxe-column field="lot.no" title="business.label.lotNo" width="110"/>
      <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
      <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="150"/>
      <vxe-column field="location.no" title="business.label.location" width="110"/>
      <vxe-column field="storageRoom.name" title="business.label.storageRoom" width="100"/>
      <vxe-column field="maintenance.inventoryState" title="business.label.inventoryState" width="70">
        <span slot-scope="{row}">{{ inventoryStates.find(item => item.ordinal === row.maintenance.inventoryState).name }}</span>
      </vxe-column>
      <vxe-column field="maintenance.inventoryQuantity" title="business.label.invQuantity" width="80"/>
      <vxe-column :edit-render="{autofocus: '.vxe-input--inner'}" field="maintenance.quantity" title="span.maintenanceQuantity" width="100">
        <template #edit="{ row }">
          <vxe-input v-model="row.maintenance.quantity" :min="1" align="center" placeholder="" type="number"/>
        </template>
      </vxe-column>
      <vxe-column field="maintenance.maintenanceWay" title="span.maintenanceMeasure" :edit-render="{}">
        <template #default="{ row }">
          {{ row.maintenance.maintenanceWay === undefined || row.maintenance.maintenanceWay === null ? null : maintenanceWays.find(item => item.ordinal === row.maintenance.maintenanceWay).name }}
        </template>
        <template #edit="{ row }">
          <vxe-select v-model="row.maintenance.maintenanceWay" transfer>
            <vxe-option v-for="d in maintenanceWays" :key="d.ordinal" :label="d.name" :value="d.ordinal"/>
          </vxe-select>
        </template>
      </vxe-column>
      <vxe-column field="maintenance.notes" title="span.maintenanceAdvice" :edit-render="{autofocus: '.vxe-input--inner'}">
        <template #edit="{ row }">
          <vxe-input v-model="row.maintenance.notes" align="center" placeholder="" type="text"/>
        </template>
      </vxe-column>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>
<script>
import { del, findAll, findEnum, post } from '@/api/Api'
import Api from '@/api'
import moment from 'moment/moment'
import Vue from 'vue'
import { OPERATOR, SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
    name: 'MaintenancePlan',
    data() {
      return {
        operator: Vue.ls.get(OPERATOR),
        data: [],
        inventoryStates: [],
        maintenanceWays: [],
        contentSize: 0,
        page: 1,
        size: 20,
        loading: false,
        query: {
          'item.no': '',
          'item.name': '',
          'lot.no': '',
          'location.no': '',
          executed: false
        },
        batchEdit: {
          maintenanceWay: undefined,
          maintainAdvice: ''
        },
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.815),// 表格竖向滚动条
        editRules: {
          'maintenance.quantity': [
            {required: true, min: 1, type: 'number', message: '养护数量需大于0'}
          ]
        },
        editConfig: {trigger: 'click', mode: 'cell', showStatus: true}
      }
    },
    mounted() {
      findEnum('InventoryState').then(res => {
        if (res.success) {
          this.inventoryStates = res.result
        }
      })
      findEnum('MaintenanceWay').then(res => {
        if (res.success) {
          this.maintenanceWays = res.result
        }
      })
    },
    methods: {
      moment,
      pageChange({currentPage, pageSize}) {
        this.page = currentPage
        this.size = pageSize
        this.getData()
      },
      getData() {
        this.data = []
        this.loading = true
        findAll('maintenanceFactory', this.query, this.page, this.size).then(res => {
          if (res.success) {
            this.data = res.result
            this.contentSize = res.contentSize
          }
        }).finally(() => {
          this.loading = false
        })
      },
      search() {
        this.page = 1
        this.getData()
      },
      reset() {
        this.query = {
          'item.no': '',
          'item.name': '',
          'lot.no': '',
          'location.no': '',
          executed: false
        }
        this.batchEdit = {
          maintenanceWay: undefined,
          maintainAdvice: ''
        }
        this.getData()
      },
      batchEditMaintenanceWay() {
        const dataSource = [...this.data]
        this.data = []
        this.$nextTick(() => {
          dataSource.forEach(item => {
            item.maintenance.maintenanceWay = this.batchEdit.maintenanceWay
          })
          this.data = dataSource
        })
      },
      batchEditMaintainAdvice() {
        const dataSource = [...this.data]
        this.data = []
        this.$nextTick(() => {
          dataSource.forEach(item => {
            item.maintenance.notes = this.batchEdit.maintainAdvice
          })
          this.data = dataSource
        })
      },
      del() {
        let selectedRows = this.$refs.table.getCheckboxRecords()
        if (selectedRows.length === 0) {
          return this.$message.warning('请选中需要删除的明细')
        }
        this.loading = true
        del(Api.deleteAll, {type: 'maintenanceDeleter'}, {ids: selectedRows.map(item => item.maintenance.id)}).then(res => {
          if (res.success) {
            this.$message.success(this.$t('message.deleteSuccess'))
            this.getData()
          }
        }).finally(() => {
          this.loading = false
        })
      },
      async maintain() {
        let selectedRows = this.$refs.table.getCheckboxRecords()
        if (selectedRows.length === 0) {
          return this.$message.warning('请选择需要养护的计划')
        }
        const errMap = await this.$refs.table.validate(true)
        if (errMap) {
          return
        }
        this.loading = true
        let args = []
        selectedRows.forEach(item => {
          let arg = {
            id: item.maintenance.id,
            assessment: 1,
            maintainer: this.operator.name,
            quantity: item.maintenance.quantity,
            maintenanceWay: item.maintenance.maintenanceWay,
            notes: item.maintenance.notes
          }
          args.push(arg)
        })
        post(Api.conversionMaintainerExecute, {}, args).then(res => {
          if (res.success) {
            this.$message.success('养护成功')
            this.getData()
          }
        }).finally(() => {
          this.loading = false
        })
      },
      generate() {
        this.loading = true
        post(Api.schedulingSchedule.replace('{type}', 'maintenanceGeneration'), {}).then(res => {
          if (res.success) {
            this.$message.success('养护计划生成成功')
            this.getData()
          }
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
</script>
<style scoped>
  .columnHeader {
    font-weight: bold;
    color: #404040;
  }

  .query {
    width: 200px;
  }
</style>